import { ParametrosWSBase, DestinoConexion } from "../ParametrosWSBase";
import { EncabezadoRespuestaInterna } from "../EncabezadoRespuestaInterna";

export function ConsultarCuentaEspecial_Parametros(datos: any) {
  var par: ParametrosWSBase = {
    nombreProceso: "consultarCuentaEspecial",
    rutaEndPoint: "/EnterpriseServices/Siebel/Cuenta/consultarCuentaEspecial",
    sistemaOrigen: "SEL",
    AGREGAR_ENCABEZADO: true,
    DESTINO_SERVICIO: DestinoConexion.Proxy,
    parametros: { ...datos },
        cRC:null
  };

  return par;
}

//ENTRADA

export interface ConsultarCuentaEspecial_Entrada {
  CuentaSKY: string;
}

export function builtConsultarCuentaEspecial_Entrada(p_CuentaSKY: string) {
  var retorno: ConsultarCuentaEspecial_Entrada = {
    CuentaSKY: p_CuentaSKY,
  };

  return retorno;
}

//SALIDA
export interface ConsultarCuentaEspecial_Salida {
  resultado: string;
  resultadodesc: string;
  RowId: string;
  CuentaSKY: string;
  RowIdCuentaPadre: string;
  CuentaSKYPadre: string;
  NombreGrupo: string;
  FlagCorporativo: string;
  FlagVIP: string;
  TipoCuenta: string;
  CodigoPais: string;
}

export type ConsultarCuentaEspecial_Respuesta = ConsultarCuentaEspecial_Salida;
